import React, { useRef } from 'react';
import { IconButton, Box, Tooltip, Popover, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import ListIcon from '@mui/icons-material/List';

import SidebarFavoritesTree from '../Sidebar/SidebarFavoritesTree';

const headerDrawerStyles = makeStyles((theme) => ({
    appHeaderDrawer: {
        width: 300,
        maxWidth: '80vw',
        minHeight: 120,
        maxHeight: '70vh',
        overflowY: 'auto',
        padding: '8px 0'
    }
}));

function HeaderDrawer() {
    const classes = headerDrawerStyles();
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
    const anchorRef = useRef(null);

    const [open, setOpen] = React.useState(false);

    if (!isMdUp) return null;

    return (
        <>
            <Box ml={2}>
                <Tooltip title="Favorites" placement="right">
                    <IconButton
                        ref={anchorRef}
                        color="inherit"
                        onClick={() => setOpen((prev) => !prev)}
                        size="medium"
                    >
                        {open ? <MenuOpenRoundedIcon /> : <ListIcon />}
                    </IconButton>
                </Tooltip>
            </Box>
            <Popover
                open={open}
                anchorEl={anchorRef.current}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                elevation={4}
            >
                <Box className={classes.appHeaderDrawer}>
                    <SidebarFavoritesTree />
                </Box>
            </Popover>
        </>
    );
}

export default HeaderDrawer;
